export const FETCH_TELEPHONE_BOOKING = 'FETCH_TELEPHONE_BOOKING'
export const RECEIVE_TELEPHONE_BOOKING = 'RECEIVE_TELEPHONE_BOOKING'
export const TELEPHONE_BOOKING_ERROR = 'TELEPHONE_BOOKING_ERROR'
export const CLEAR_TELEPHONE_BOOKING = 'CLEAR_TELEPHONE_BOOKING'
export const CHECKOUT_FORM_INIT = 'TELEPHONE_CHECKOUT_FORM_INIT'
export const CHECKOUT_FORM_RESET = 'TELEPHONE_CHECKOUT_FORM_RESET'
